import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { RadioButtonInputModel } from 'src/app/presentation/general/radio-button/radio-button.component';
import { Subscription } from 'rxjs';
import { SubmitButtonShared } from 'src/app/presentation/general/shared/submit-button-shared';
import { GenerateShared } from 'src/app/presentation/general/shared/generate-shared';
import { HatedFoodService } from 'src/app/data/repository/generate-repository/hated-food.service';
import { LoadingShared } from 'src/app/presentation/general/shared/loading-shared';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';

@Component({
  selector: 'app-hated-foods',
  templateUrl: './hated-foods.component.html',
  styleUrls: ['./hated-foods.component.scss'],
})
export class HatedFoodsComponent implements OnInit, OnDestroy {
  @Input() isDetail = false;
  @Input() pageNumber: number;
  @Input() currentPageNumber: number;

  configButtons: RadioButtonInputModel[] = new Array();

  subscription: Subscription;

  constructor(
    private submitButtonShared: SubmitButtonShared,
    private generateShared: GenerateShared,
    private hatedFoodService: HatedFoodService,
    private loadingShared: LoadingShared,
    private snackBarService: SnackBarService
  ) {
    this.subscription = this.submitButtonShared.nextButtonClickObs$.subscribe(
      (clicked) => {
        if (clicked && this.pageNumber === this.currentPageNumber) {
          if (this.isDetail) {
            this.generateShared.closeOverviewDetail();
          } else {
            this.generateShared.nextPage();
          }
          // console.log('hated', this.generateShared.getHatedFoods())
        }
      }
    );
  }

  ngOnInit() {
    let titles = [];
    this.loadingShared.showLoading();
    this.hatedFoodService
      .getHatedFoodsServer()
      .then((res) => {
        if (res.isSuccess()) {
          titles = [];
          this.hatedFoodService.getHatedFoods().then((response) => {
            response.hatedfoods.forEach((hatedfood) => {
              titles.push(hatedfood.name);
            });
          });
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          titles = [];
        }
        this.loadingShared.hideLoading();
      })
      .then(() => {
        for (let i = 0; i < titles.length; i++) {
          this.configButtons.push({
            title: titles[i],
            id: i,
            type: 'hatedFood',
          });
        }
      });
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
